import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Avatar, Row, Col, Pagination, message, Modal, Table, Select } from "antd";
import * as actions from "../../../store/actions/index";
import * as leadActions from "../../../store/actions/leads";
import { useHistory } from "react-router-dom";
import Tabs from "../../../components/Tab/Tab";
import _ from "lodash";
import axiosRequest from "../../../axios-request/request.methods";
import "./ApplicationAll.css";
import NoRecordsFound from "../../NoRcordsFound/NoRecordsFound";
import Loader from "../../Loader/Loader";
import axios from "axios";
import apiConfig from "../../../config/api.config";
import { stoageSetter, stoageGetter, checkAgent, checkPartnerUser } from "../../../helpers";
import { renderEnachStatus, renderMandateStatus } from "./SubsequentPaymentUtility";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { routeAsPerProposalStatus, isGiftCityChannel } from "../../../config/router.config";
import TriggerSubsequentPayment from "./TriggerSubsequentPayment";
import { AthenaProductsRouteHandler, PaymentFrequencyConvertor } from "../../../config/product.config";
import TeamPerformanceTable from "../teamPerformanceTable";
import FilterDropdown from "../filterDropdown";
import { getUniqueArray } from "../../../store/utility";
import { renderMedicalTestStatus } from "./ProposalStatusUtility";


const { baseURL } = apiConfig;

export const tabMenuApplication = [
  {
    id: "ApplicationAll",
    value: "All",
  },
  {
    id: "WIPApplication",
    value: "WIP",
  },
  {
    id: "PendingApplication",
    value: "Pending For Processing",
  },
  {
    id: "IssuedApplication",
    value: "Completed",
  },
  {
    id: "RTSApplication",
    value: "RTS",
  },
  // {
  //   id: "RejectedApplication",
  //   value: "Rejected",
  // },
];

const ApplicationAll = () => {
  const columns = [
    {
      title: "Substage",
      dataIndex: "substage",
      key: "name1",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "name2",
    },
  ];

  const selectedFilter = useSelector(state => state.leads.selectedFilterByVal);
  const [width, setWidth] = useState(window.innerWidth);
  const [fetchApplicationList, setfetchApplicationList] = useState([]);

  const [currentPageNumber, setcurrentPageNumber] = useState(1);
  const [proposalNumberSearch, setProposerNumberSearch] = useState("");
  const [proposalStatus, setProposalStatus] = useState("");
  const [totalLeads, settotalLeads] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [PolicyRes, setPolicyRes] = useState("");

  const [isshowMore, setisshowMore] = useState([]); //show more index values
  const [loader, setLoader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPopover, setIsPopover] = useState(false);
  const [currentIndex, setCurrentIndex] = useState("");
  const [PolicyId, setPolicyId] = useState("");
  const [firstValue, setFirstValue] = useState("");
  const [secondValue, setSecondValue] = useState(null);
  const [openSecond, setOpenSecond] = useState(false);
  const [secondDropData, setSecondDropData] = useState([]);
  const [firsrDrop, setFirstDrop] = useState([]);
  const [currentFilter, setCurrentFilter] = useState(selectedFilter);

  const dispatch = useDispatch();
  const history = useHistory();
  const [StoreHistoryRes, setStoreHistoryRes] = useState("");
  const [showSubPaymentModal, setShowSubPaymentModal] = useState(false);
  const [triggerSubPaymentData, setTriggerSubPaymentData] = useState(null);

  const id = useSelector((state) => state.login?.user.id);
  const userData = useSelector((state) => state.login?.user);
  const leadsData = useSelector((state) => state.leads);
  const showProposalTable = useSelector((state) => state.leads.showProposalTable);
  const userTreeData = useSelector((state) => state?.home?.user_tree);
  const userId = useSelector((state) => state?.login?.userId);
  const getleads = useSelector((state) => state.leads.currentActiveTab);
  const LeadID = useSelector((state) => state?.needAnalysis?.needAnalysisData?.payload?.leadId);
  const medicalTestMaster = useSelector((state) => state.leads.medicalTestMaster);
  const fetchMedicalTestMasterLoading = useSelector((state) => state.leads.fetchMedicalTestMasterLoading);

  const breakpoint = 620;

  const WebHeightProduct = { height: width > breakpoint ? "30px" : "" };

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [width]);

  // useEffect(() => {
  //   // console.log('I AM RUNNING',leadsData.proposalTeamData)
  //   getItemToDisplayFromStatus(currentPageNumber, proposalStatus);
  // }, []);

  useEffect(() => {
    // getItemsToDisplay(currentPageNumber, proposalNumberSearch);
    getDataForFirstDropdownTeam()

    // Fetch medical test master
    dispatch(leadActions.fetchMedicalTestMaster());

    // Check if we have current dropdown state, preserve it over localStorage
    let hierarchyId = stoageGetter("hierarchyId");
    let teamId = stoageGetter("teamMemberId");

    if (hierarchyId && teamId && leadsData?.globalTab === "team") {
      // Restore dropdown state from localStorage when component mounts
      setFirstValue(hierarchyId);
      let _teamData = getUniqueArray(userTreeData?.reporting_users?.filter((el) => el.hierarchy_id === hierarchyId), "_id");
      setSecondDropData(_teamData);
      setSecondValue(teamId);
      setOpenSecond(true);
    } else if (leadsData?.proposalTeamData && Object.keys(leadsData?.proposalTeamData).length !== 0) {
      handleTeamMemberClick(leadsData?.proposalTeamData)
    }
  }, []);

  // Reset team member selection when switching back to Self tab
  useEffect(() => {
    if (leadsData?.globalTab === "self") {
      setSecondValue("");
      setOpenSecond(false);
      // Trigger API call to fetch current user's proposals
      getItemsToDisplay(currentPageNumber, proposalNumberSearch);
      // getItemToDisplayFromStatus(currentPageNumber, proposalStatus);
    }
  }, [leadsData?.globalTab]);

  useEffect(() => {
    // console.log("((((((((((secondValue)))))))))):-=======---=====-->>>", secondValue);
    if (secondValue) {
      // Fetch proposals for the selected team member after the state update
      setcurrentPageNumber(1);
      getItemsToDisplay(1, proposalNumberSearch);
      // getItemToDisplayFromStatus(1, proposalStatus, secondValue);
    }
  }, [secondValue]);

  const getItemsToDisplay = async (Nextpage, policyId, filterbyValue) => {
    setLoader(true);
    let res = null;
    // Determine the correct userId based on team member selection and hierarchy level
    let dynamicUserId = id; // Default to current user's id

    // dynamicUserId = leadsData?.globalTab === "team" && leadsData?.proposalTeamData ? leadsData?.proposalTeamData?._id || secondValue : id
    dynamicUserId = leadsData?.globalTab === "team" && secondValue ? secondValue : id
    let _filter = leadsData?.globalTab === "self" ? "all" : filterbyValue || currentFilter;
    console.log('Current filter in RTSApplication:', leadsData?.globalTab, filterbyValue, currentFilter);
    res = await axiosRequest.get(`user/get_agent_proposal/${dynamicUserId}?proposalStatus=all&skip=${(Nextpage - 1) * 15}&sort_status=&sortByFlter=Proposalstarted&searchByDisplayProposal=${proposalStatus}&searchType=policyId&searchtxt=${policyId}&filterby=${_filter}`);

    console.log("page new result-->", res);
    if (res?.errCode === 529) {
      setfetchApplicationList([]);
      settotalLeads(0);
      setLoader(false);
    } else if (res.length > 0) {
      setfetchApplicationList(res[0]);
      settotalLeads(res[1][0].count);
      setLoader(false);
    } else {
      setLoader(false);
      return <NoRecordsFound />;
    }
  };

  //------------- filter by status api call start -----------------------
  const getItemToDisplayFromStatus = async (Nextpage, status, teamMemberId) => {
    setLoader(true);
    let res = null;

    // Determine the correct userId based on team member selection and hierarchy level
    let dynamicUserId = id; // Default to current user's id
    dynamicUserId = leadsData?.globalTab === "team" && secondValue ? secondValue : id

    res = await axiosRequest.get(`user/get_agent_proposal/${dynamicUserId}?proposalStatus=all&skip=${(Nextpage - 1) * 15}&sort_status=&sorByFlter=Proposalstarted&searchByDisplayProposal=${status}`);
    if (res?.errCode === 529) {
      setfetchApplicationList([]);
      settotalLeads(0);
      setLoader(false);
    } else if (res.length > 0) {
      setLoader(false);
      setfetchApplicationList(res[0]);
      settotalLeads(res[1][0].count);
    } else {
      setLoader(false);
      return <NoRecordsFound />;
    }
  };

  //------------- filter by status api call start -----------------------

  const getRandomColor = () => {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const nameShorter = (str) => {
    let str1 = "UU";
    if (str != "" && str != undefined) {
      str1 = str?.toUpperCase();
      let arr = str1?.split(" ");
      let fLatter = arr[0]?.charAt(0);
      let sLatter = arr[1]?.charAt(0);
      str1 = (fLatter || "UU") + (sLatter || "");
    }
    return str1;
  };

  const routeHandler = async (item) => {
    var id = "";
    var productCode = "";
    productCode = item?.productId?.product_code;
    console.log("Itme", item)
    id = item._id;
    let ProposalLocalID = {
      proposalID: id,
      policyId: item?.policyId,
    };
    stoageSetter("propsalid", ProposalLocalID);

    let tracker_res = await axiosRequest.get(`user/getProposal/${id}`);

    if (tracker_res?.errCode !== 256) {
      dispatch(actions.fetchAllProposalSuccess(tracker_res[0]));
      dispatch(actions.fetchBi(tracker_res[0]?.benefitIllustration));
      dispatch(actions.fetchEinsurance(tracker_res[0]?.elinsuranceAccountDetails));
      dispatch(actions.fetchFinancialDetails(tracker_res[0]?.FinancialDetails));
      dispatch(actions.fetchAboutCustomer(tracker_res[0]?.AboutCustomer));
      dispatch(actions.fetchHealthDetails(tracker_res[0]?.HealthDetailsSection));
      dispatch(actions.fetchPreviousPolicyDetails(tracker_res[0]?.PreviousPolicyDetails));
      dispatch(actions.fetchNominationDetails(tracker_res[0]?.NominationDetails));
      dispatch(actions.fetchProposalDetails(tracker_res[0]?.ProposerDetails));
      dispatch(actions.fetchPayments(tracker_res[0]?.paymentOptions));
      dispatch(actions.AddENACHDetails(tracker_res[0]?.eNachStatus));

      dispatch(actions.fetchDelaration(tracker_res[0]?.Declaration));

      const routingURL = routeAsPerProposalStatus(item);

      if (routingURL === "currentLocationURL") {
        if (item?.currentLocationURL === null || item?.currentLocationURL === undefined || item?.currentLocationURL === "") {
          AthenaProductsRouteHandler(history, productCode);
        } else {
          history.push(item?.currentLocationURL);
        }
      } else {
        history.push(routingURL);
      }
    }
  };

  // New function to handle View Details click for team view
  const handleViewDetails = async (item) => {
    var id = "";
    var productCode = "";
    productCode = item?.productId?.product_code;

    id = item._id;
    let ProposalLocalID = {
      proposalID: id,
      policyId: item?.policyId,
    };
    stoageSetter("propsalid", ProposalLocalID);
    const login_user_data = stoageGetter("user");
    const employeeCode = login_user_data?.employeeCode;
    let getproposalApi = `user/getProposal/${id}`;

    if (leadsData?.globalTab === "team") {
      getproposalApi = `user/getProposal/${id}?Supervisar_id=${employeeCode}&view_details=true`
    }

    let tracker_res = await axiosRequest.get(getproposalApi);

    if (tracker_res?.errCode !== 256) {
      dispatch(actions.fetchAllProposalSuccess(tracker_res[0]));
      dispatch(actions.fetchBi(tracker_res[0]?.benefitIllustration));
      dispatch(actions.fetchEinsurance(tracker_res[0]?.elinsuranceAccountDetails));
      dispatch(actions.fetchFinancialDetails(tracker_res[0]?.FinancialDetails));
      dispatch(actions.fetchAboutCustomer(tracker_res[0]?.AboutCustomer));
      dispatch(actions.fetchHealthDetails(tracker_res[0]?.HealthDetailsSection));
      dispatch(actions.fetchPreviousPolicyDetails(tracker_res[0]?.PreviousPolicyDetails));
      dispatch(actions.fetchNominationDetails(tracker_res[0]?.NominationDetails));
      dispatch(actions.fetchProposalDetails(tracker_res[0]?.ProposerDetails));
      dispatch(actions.fetchPayments(tracker_res[0]?.paymentOptions));
      dispatch(actions.AddENACHDetails(tracker_res[0]?.eNachStatus));

      dispatch(actions.fetchDelaration(tracker_res[0]?.Declaration));

      // Route to appropriate tab based on proposal status
      const routingURL = routeAsPerProposalStatus(item);

      if (routingURL === "currentLocationURL") {
        if (item?.currentLocationURL === null || item?.currentLocationURL === undefined || item?.currentLocationURL === "") {
          AthenaProductsRouteHandler(history, productCode);
        } else {
          history.push(item?.currentLocationURL);
        }
      } else {
        history.push(routingURL);
      }
    }
  };

  const handlePageClick = async (page) => {
    setcurrentPageNumber(page);
    await getItemsToDisplay(page, proposalNumberSearch);
    await getItemToDisplayFromStatus(page, proposalStatus);
    await setisshowMore([]);
  };

  const showMoreFunc = (index) => {
    let new_val = [...isshowMore];
    new_val.push(index);
    setisshowMore(new_val);
  };
  const showLessFunc = (index) => {
    let new_val = [...isshowMore];
    _.remove(new_val, (new_val_item) => new_val_item == index);
    setisshowMore(new_val);
  };

  const showJourneyTerminateReason = (reason) => {
    if (reason.includes("Kindly explore other products.")) {
      let newReason = reason.split("Kindly explore other products.");
      let reasonToDisplay = newReason[0];
      message.warn(reasonToDisplay);
    } else {
      message.warn(reason);
    }
  };

  const ViewHeadline = (e) => {
    let ProposalLocalID = {
      proposalID: e?._id,
    };
    stoageSetter("propsalid", ProposalLocalID);
    history.push("/finalSubmit");
  };

  const isRTSPresent = (item) => {
    const statuses = [item?.NB_Status, item?.UW_Status, item?.PSC_Status];
    const present = !statuses.every((status) => status === undefined || status === 0);

    return present;
  };

  const RouteToRTS = (item) => {
    if (isRTSPresent(item) === true) {
      Modal.confirm({
        title: "Alert",
        content: (
          <div>
            Please ensure to upload required documents that are correctly <strong style={{ color: "blue" }}>OSVed</strong> or <strong style={{ color: "blue" }}>Self Attested</strong>
          </div>
        ),
        okText: "Proceed", // Set the text for the OK button
        onOk() {
          let ProposalLocalID = {
            proposalID: item?._id,
            policyId: item?.policyId,
          };
          stoageSetter("propsalid", ProposalLocalID);

          history.push(`/rts-details/${item?.policyId}`);
        },
      });
    } else {
      message.warning("No current RTS exist against this policy");
    }
  };

  const handleTriggerSubsequentPayment = async (item) => {
    const result = await axiosRequest.get(`user/checkMandateRetry?proposalId=${item?.policyId}`);

    if (result?.retry === true) {
      setTriggerSubPaymentData(item);
      setShowSubPaymentModal(true);
    }
  };

  const handleProposalFilter = (policyId) => {
    setProposerNumberSearch(policyId);

    if (policyId === "" || policyId === null || policyId === undefined) {
      getItemsToDisplay(currentPageNumber, policyId);
    } else {
      setcurrentPageNumber(1);
      getItemsToDisplay(1, policyId);
    }
  };

  const handleProposalStatusFilter = (status) => {
    setProposalStatus(status);

    if (status === "" || status === null || status === undefined) {
      getItemToDisplayFromStatus(currentPageNumber, status);
    } else {
      setcurrentPageNumber(1);
      getItemToDisplayFromStatus(1, status);
    }
  };

  const pageLoadAfterSubsequent = () => {
    getItemsToDisplay(currentPageNumber, proposalNumberSearch);
  };

  let toCapitalize = (strText) => {
    try {
      if (strText !== "" && strText !== null && typeof strText !== undefined) {
        var _str = strText.toLowerCase();
        var collection = _str.split(" ");
        var modifyStrigs = [];
        _str = "";
        for (var i = 0; i < collection.length; i++) {
          modifyStrigs[i] = collection[i].charAt(0).toUpperCase() + collection[i].slice(1);
          _str = _str + modifyStrigs[i] + " ";
        }
        return _str;
      } else {
        return "";
      }
    } catch (err) { }
  };

  const getDataForFirstDropdownTeam = () => {
    let hierarAgentList = userTreeData?.reporting_hierarchies;
    hierarAgentList?.forEach((el) => {
      el.label = el.dispValue;
    });
    userTreeData?.reporting_users?.forEach((el) => {
      el.label = el.full_name;
      el.value = el._id;
    });
    setFirstDrop(hierarAgentList);
  };

  const handleFirstDropdown = (event) => {
    event ? setOpenSecond(true) : setOpenSecond(false);
    setFirstValue(event);
    stoageSetter("hierarchyId", event);
    setSecondValue("");
    userTreeData?.reporting_users?.forEach((el) => {
      el.label = toCapitalize(el.full_name);
      el.value = el._id;
    });
    let _teamData = getUniqueArray(
      userTreeData?.reporting_users?.filter((el) => el.hierarchy_id === event),
      "_id"
    );
    setSecondDropData(_teamData);
    if (_teamData.length > 0) {
      setSecondValue(_teamData[0]._id);
      stoageSetter("teamMemberId", _teamData[0]._id);
    }
  };
  const handleSecondDropdown = async (event) => {
    setSecondValue(event);
    stoageSetter("teamMemberId", event);

    // let agentId = "";
    // if (leadsData?.globalTab === "team") {
    //   agentId = event;
    // } else {
    //   agentId = userId;
    // }
  };

  const handleTeamMemberClick = (member) => {
    // 🔹 Step 1: Clear data for immediate refresh
    setfetchApplicationList([]);
    setSecondDropData([]); // Prevent old/duplicate data before setting new one

    // 🔹 Step 2: Get any stored hierarchy/team data
    const hierarchyId = stoageGetter("hierarchyId");
    const teamId = stoageGetter("teamMemberId");

    console.log("hierarchyId (stored):", hierarchyId);
    console.log("teamId (stored):", teamId);

    // 🔹 Step 3: Determine active hierarchy (prefer member value)
    const activeHierarchyId = member.hierarchy_id || hierarchyId;
    if (activeHierarchyId) {
      setFirstValue(activeHierarchyId);
      stoageSetter("hierarchyId", activeHierarchyId);

      // Filter team members by hierarchy
      const _teamData =
        userTreeData?.reporting_users?.filter(
          (el) => el.hierarchy_id === activeHierarchyId
        ) || [];

      // 🔹 Deduplicate team data (by _id)
      const uniqueTeamData = getUniqueArray(_teamData)


      setSecondDropData(uniqueTeamData);
      console.log("Unique team dropdown data:", uniqueTeamData);
    }

    // 🔹 Step 4: Determine active team member (prefer member value)
    const activeTeamMemberId = member._id || teamId;
    if (activeTeamMemberId) {
      setSecondValue(activeTeamMemberId);
      stoageSetter("teamMemberId", activeTeamMemberId);
    }

    // 🔹 Step 5: Dispatch Redux actions
    dispatch(leadActions.proposalTeamSelect(true));
    dispatch(leadActions.showProposalTable(true));

    // 🔹 Step 6: Update UI state
    setOpenSecond(true);
    setcurrentPageNumber(1);

    // ✅ Avoid logging stale React state values
    // Use useEffect if you need to react to changes
    console.log("Active member selected:", member._id || teamId);
    console.log("Hierarchy in use:", member.hierarchy_id || hierarchyId);
  };

  const handleFilterUpdate = (value) => {
    setCurrentFilter(value);
    console.log('Selected filter in parent:', value);
    getItemsToDisplay(1, proposalNumberSearch, value);
  };

  return (
    <>
      <Tabs header="Applications" tabMenu={tabMenuApplication} activeKey="ApplicationAll" proposalFilter={handleProposalFilter} handleProposalStatusFilter={handleProposalStatusFilter} />
      <>
        <Loader formloader={loader || fetchMedicalTestMasterLoading} />
      </>

      {showProposalTable ? (
        <>
          <div className="main_tab_1" style={{ marginLeft: "5rem" }}>
            <Row align="middle">
              <Row gutter={16} style={{ flex: 1 }}>
                {leadsData?.globalTab === "team" && (
                  <FilterDropdown onFilterChange={handleFilterUpdate} />
                )}
                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                  {leadsData?.globalTab === "team" && (
                    <div className="hierarchy">
                      <p style={{ marginBottom: "5px" }}>Select Hierarchy</p>
                      <Select className="firstdropdown" value={firstValue} style={{ width: "100%" }} onChange={handleFirstDropdown} placeholder="Select Hierarchy" options={firsrDrop}></Select>
                    </div>
                  )}
                </Col>
                <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                  {openSecond && leadsData?.globalTab === "team" && (
                    <div className="hierarchy">
                      <p style={{ marginBottom: "5px" }}>Select Team Member</p>
                      <Select className="seconddropdown" value={secondValue} style={{ width: "100%" }} onChange={(item) => handleSecondDropdown(item)} placeholder="Select Team Member" options={secondDropData}></Select>
                    </div>
                  )}
                </Col>
              </Row>
              <Col style={{ marginRight: "5rem" }} onClick={() => dispatch(leadActions.showProposalTable(false))}>
                {/* <p style={{ marginBottom: "0px",fontWeight: "bold" }}>Table View</p> */}
              </Col>
            </Row>
          </div>
          <Row justify="center">
            {!fetchApplicationList ? (
              <Loader formloader={loader} />
            ) :
              (
                fetchApplicationList?.map((item, index) => (
                  <Col xm={18} sm={18} md={18} lg={11} xl={11} index={index} key={index} style={{ width: "100%" }}>
                    <div className="LeadCard-Main-Page-Container">
                      <Card className="lead-card-desktop" hoverable={false}>
                        <div className="main-avtar">
                          <div className="avatar-and-status">
                            <Avatar
                              style={{
                                backgroundColor: getRandomColor(),
                              }}
                              size={45}
                            >
                              {nameShorter(item.benefitIllustration.NameofLifeAssured)}
                            </Avatar>
                          </div>
                        </div>
                        <div className="mainContent">
                          <div className="content">
                            <div className="content-header1">
                              <div className="avtar-data">
                                <div className="otp-data1">
                                  <p className="user-name-text capitalize">{item?.benefitIllustration?.NameofLifeAssured}</p>
                                  <span className="user-id user-name-text uppercase">{/* {item?.policyId} */}</span>
                                </div>
                              </div>
                            </div>
                            <hr
                              style={{
                                width: "95%",
                                margin: "3px -30px 4px 0px",
                                opacity: "0.5",
                                color: "lightgray",
                              }}
                            />

                            {width < 620 ? (
                              <>
                                <Row gutter={16}>
                                  <Col xs={21} sm={21} md={21} lg={24} xl={24}>
                                    <label style={{ fontSize: 12 }}>
                                      <b>Product Name</b>
                                    </label>
                                    <div>{item?.productId?.productName}</div>
                                  </Col>
                                </Row>

                                <Row gutter={16}>
                                  <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                    <label style={{ fontSize: 12 }}>
                                      <b>Proposal Number</b>
                                    </label>
                                    <div>{item?.policyId}</div>
                                  </Col>
                                  <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                    <label style={{ fontSize: 12 }}>
                                      <b>Draft Date</b>
                                    </label>
                                    <div>{item?.lastupdatedOn}</div>
                                  </Col>
                                </Row>

                                {width < 620 && !isshowMore.includes(index) ? null : (
                                  <>
                                    <Row gutter={16}>
                                      <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                        <label style={{ fontSize: 12 }}>
                                          <b>Premium Frequency</b>
                                        </label>
                                        <div>{PaymentFrequencyConvertor(item?.benefitIllustration?.PremiumMode)}</div>
                                      </Col>
                                      <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                        <label style={{ fontSize: 12 }}>
                                          <b>Policy Term</b>
                                        </label>
                                        <div>{item.benefitIllustration?.PolicyTerm ? `${item.benefitIllustration?.PolicyTerm} year(s)` : "- years"}</div>
                                      </Col>
                                    </Row>

                                    <Row gutter={16}>
                                      <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                        <label style={{ fontSize: 12 }}>
                                          <b>Premium Amount</b>
                                        </label>
                                        <div>{item?.benefitIllustration?.annualisedPremium}</div>
                                      </Col>
                                      <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                        <label style={{ fontSize: 12 }}>Payment Status</label>
                                        <div>
                                          <label style={{ color: item?.paymentOptions?.paymentStatus === "SUCCESS" ? "green" : item?.paymentOptions?.paymentStatus === "PENDING" ? "gold" : "black" }}>{item?.paymentOptions?.paymentStatus}</label>
                                        </div>
                                      </Col>
                                    </Row>

                                    <Row gutter={16}>
                                      <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                        <label style={{ fontSize: 12 }}>
                                          <b>Mandate Status</b>
                                        </label>
                                        <div>{renderMandateStatus(item)}</div>
                                      </Col>
                                    </Row>

                                    <Row gutter={16}>
                                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <label style={{ fontSize: 12 }}>
                                          <b>Proposal Status</b>
                                        </label>
                                        <div>{item?.proposalStatus}</div>
                                      </Col>
                                    </Row>
                                    <Row gutter={16}>
                                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <label style={{ fontSize: 12 }}>
                                          <b>Opportunity ID</b>
                                        </label>
                                        <div>{item?.opportunityId || "-"}</div>
                                      </Col>
                                    </Row>
                                    <Row gutter={16}>
                                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <label style={{ fontSize: 12 }}>
                                          <b>Product of Interest</b>
                                        </label>
                                        <div>{item?.selected_Product || "-"}</div>
                                      </Col>
                                    </Row>

                                    {/* Enach status */}
                                    <Row gutter={16}>
                                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <label style={{ fontSize: 12 }}>
                                          <b>Enach Status</b>
                                        </label>
                                        <div>{renderEnachStatus(item) || "-"}</div>                                    
                                      </Col>
                                    </Row>

                                    <Row gutter={16} style={{ marginTop: "10px" }}>
                                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <label style={{ fontSize: 12 }}>
                                          <b>Medical Test Status</b>
                                        </label>
                                        <div>{renderMedicalTestStatus(item, medicalTestMaster)}</div>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                              </>
                            ) : (
                              // *************For Desktop*************
                              <div className="content-body Datainfo-Main-Container">
                                <div className="Dateinfo-Container-imp">
                                  <Card.Grid hoverable={false} className="grid-style">
                                    <p className="text-type">Proposal Number</p>
                                    <p className="text-content">{item?.policyId}</p>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false} className="grid-style">
                                    <p className="text-type">Product Name</p>
                                    <p className="text-content-v2" style={WebHeightProduct}>
                                      {item?.productId?.productName}
                                    </p>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false} className="grid-style">
                                    <p className="text-type">Mandate Status</p>
                                    <p className="text-content">{renderMandateStatus(item)}</p>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false} className="grid-style">
                                    <p className="text-type">Premium Frequency</p>
                                    <p className="text-content">{PaymentFrequencyConvertor(item?.benefitIllustration?.PremiumMode)}</p>
                                  </Card.Grid>

                                  <Card.Grid hoverable={false} className="grid-style AllocatedBy-Heading">
                                    <p className="text-type">Policy Term</p>
                                    <p className="text-content">{item.benefitIllustration?.PolicyTerm ? item.benefitIllustration?.PolicyTerm : "- years"}</p>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                                    <p className="text-type">Draft Date</p>

                                    <p className="text-content">{item?.lastupdatedOn}</p>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false} className="grid-style">
                                    <p className="text-type">Premium Amount</p>
                                    <p className="text-content">{item?.benefitIllustration?.annualisedPremium}</p>
                                  </Card.Grid>

                                  <Card.Grid hoverable={false} className="grid-style">
                                    <p className="text-type">Payment Status</p>
                                    <p className="text-content" style={{ fontWeight: "bold", color: item?.paymentOptions?.paymentStatus === "SUCCESS" ? "#06c106" : item?.paymentOptions?.paymentStatus === "PENDING" ? "#ffd900" : "" }}>
                                      {item?.paymentOptions?.paymentStatus}
                                    </p>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false} className="grid-style">
                                    <p className="text-type">Proposal Status</p>
                                    <p className="text-content-v2">{item?.proposalStatus}</p>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false} className="grid-style">
                                    <p className="text-type">Opportunity ID</p>
                                    <p className="text-content-v2">{item?.opportunityId || "-"}</p>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false} className="grid-style">
                                    <p className="text-type">Product of Interest</p>
                                    <p className="text-content-v2">{item?.leadId?.selected_Product || "-"}</p>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false} className="grid-style">
                                    <p className="text-type">Enach Status</p>
                                    <p className="text-content-v2">{renderEnachStatus(item) || "-"}</p>
                                  </Card.Grid>
                                  <Card.Grid hoverable={false} className="grid-style" style={{ marginTop: "10px" }}>
                                    <p className="text-type">Medical Test Status</p>
                                    <p className="text-content-v2">{renderMedicalTestStatus(item, medicalTestMaster)}</p>
                                  </Card.Grid>
                                </div>
                              </div>
                            )}
                          </div>

                          <div>
                            {width < 620 ? (
                              <>
                                <div className="card_footer_btns">
                                  {/* In team view, only show View Details button */}
                                  {leadsData?.globalTab === "team" ? (
                                    <button className="show_more_less" onClick={() => handleViewDetails(item)}>
                                      View Details
                                    </button>
                                  ) : (
                                    <>
                                      {item?.proposalStatus == "RTS Submitted" || item?.proposalStatus == "RTS Pending" ? null : isGiftCityChannel() === false && item?.mandateRetry === true ? (
                                        <button className="show_more_less" onClick={() => handleTriggerSubsequentPayment(item)}>
                                          Trigger Subsequent Payment
                                        </button>
                                      ) : null}

                                      {item?.terminateJourney === true ? (
                                        <button className="terminatedButton" onClick={() => showJourneyTerminateReason(item?.terminateReason)}>
                                          Journey Terminated
                                        </button>
                                      ) : (
                                        <>
                                          {item?.proposalStatus == "Login successful - Login Successful" ? (
                                            <button className="show_more_less" onClick={() => handleViewDetails(item)}>
                                              View Details
                                            </button>
                                          ) : item?.proposalStatus == "RTS Submitted" || item?.proposalStatus == "RTS Pending" ? (
                                            <button className="show_more_less" onClick={() => RouteToRTS(item)}>
                                              View Details
                                            </button>
                                          ) : (
                                            <button className="show_more_less" onClick={() => routeHandler(item)}>
                                              Resume
                                            </button>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                                <div>
                                  {!isshowMore.includes(index) ? (
                                    <label
                                      role="button" // Describes the role of the element
                                      onClick={() => showMoreFunc(index)}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          // Checks if Enter is pressed
                                          showMoreFunc(index);
                                        }
                                      }}
                                      className="showMoreLabel"
                                      style={{ marginTop: 15, cursor: "pointer" }}
                                    >
                                      Show More <DownOutlined />
                                    </label>
                                  ) : (
                                    <label
                                      role="button"
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          // Checks if Enter is pressed
                                          showLessFunc(index);
                                        }
                                      }}
                                      onClick={() => showLessFunc(index)}
                                      style={{ marginTop: 15, cursor: "pointer" }}
                                    >
                                      Show Less <UpOutlined />
                                    </label>
                                  )}
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                            {width < 620 ? (
                              ""
                            ) : (
                              <div className="card_below_btns_others">
                                <Row align="right">
                                  {/* In team view, only show View Details button */}
                                  {leadsData?.globalTab === "team" ? (
                                    <button className="show_more_less" onClick={() => handleViewDetails(item)}>
                                      View Details
                                    </button>
                                  ) : (
                                    <>
                                      {item?.proposalStatus == "RTS Submitted" || item?.proposalStatus == "RTS Pending" ? null : isGiftCityChannel() === false && item?.mandateRetry === true ? (
                                        <button className="show_more_less" onClick={() => handleTriggerSubsequentPayment(item)}>
                                          Trigger Subsequent Payment
                                        </button>
                                      ) : null}

                                      {item?.terminateJourney === true ? (
                                        <button className="terminatedButton" onClick={() => showJourneyTerminateReason(item?.terminateReason)}>
                                          Journey Terminated
                                        </button>
                                      ) : (
                                        <>
                                          {item?.proposalStatus == "Login successful - Login Successful" ? (
                                            <button className="show_more_less" onClick={() => handleViewDetails(item)}>
                                              View Details
                                            </button>
                                          ) : item?.proposalStatus == "RTS Submitted" || item?.proposalStatus == "RTS Pending" ? (
                                            <button className="show_more_less" onClick={() => RouteToRTS(item)}>
                                              View Details
                                            </button>
                                          ) : (
                                            <button className="show_more_less" onClick={() => routeHandler(item)}>
                                              Resume
                                            </button>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </Row>
                              </div>
                            )}
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Col>
                ))
              )}
          </Row>


          {!fetchApplicationList.length ? (
            <>
              <br />
              <NoRecordsFound />
            </>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Row gutter={16} style={{ width: "100%" }}>
                <Col sm={24} md={23} lg={23} xl={24} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Pagination responsive current={currentPageNumber} onChange={handlePageClick} total={totalLeads} defaultPageSize={15} showSizeChanger={false} />
                </Col>
              </Row>
            </div>
          )}
        </>
      ) : (
        <div style={{ padding: 20 }}>
          {userTreeData?.reporting_users?.length > 0 || userTreeData?.reporting_managers?.length > 0 ? (
            <>
              <FilterDropdown onFilterChange={handleFilterUpdate} />
              <TeamPerformanceTable showManagerColumn={(checkAgent() === true && !checkPartnerUser()) ? false : true} onTeamMemberClick={handleTeamMemberClick} />
            </>
          ) : null}
        </div>
      )
      }

      {showSubPaymentModal === true ? <TriggerSubsequentPayment isModalOpen={showSubPaymentModal} setIsModalOpen={setShowSubPaymentModal} proposalData={triggerSubPaymentData} pageLoadAfterSubsequent={pageLoadAfterSubsequent} /> : null}
    </>
  );
};

export default ApplicationAll;
